<template>
  <div class="setting-component">
    <div class="form-group">
      <label for="bidding-duration" class="form-label">
        {{ trans("live.tabs.settings.interface_tab.labels.bidding_duration") }}
      </label>
      <select v-model="interfaceData.bidding_duration" id="bidding-duration" class="form-select-field">
        <option :value="0">
          {{ trans("live.tabs.settings.interface_tab.bidding_duration_off") }}
        </option>
        <option v-for="option in options" :value="option.value" :key="option.value">{{ option.label }}</option>
      </select>
    </div>

    <div class="form-group">
      <label for="warning-flashing-duration" class="form-label">
        {{ trans("live.tabs.settings.interface_tab.labels.warning_flashing_duration") }}
      </label>
      <select
        v-model="interfaceData.warning_flashing_duration"
        id="warning-flashing-duration"
        class="form-select-field">
        <option :value="0">
          {{ trans("live.tabs.settings.interface_tab.warning_flashing_duration_off") }}
        </option>
        <option v-for="option in options" :value="option.value" :key="option.value">{{ option.label }}</option>
      </select>
    </div>
    <div class="form-group stage-b-item">
      <label for="third-button" class="form-label">
        {{ trans("live.tabs.settings.interface_tab.labels.third_button") }}
      </label>
      <select v-model="interfaceData.third_button" id="third-button" class="form-select-field">
        <option v-for="option in SettingThirdButton" :value="option" :key="option">
          {{ trans(`live.tabs.settings.interface_tab.third_button.${option}`) }}
        </option>
      </select>
    </div>
    <div class="form-group">
      <custom-checkbox
        id="show-bid-increments"
        v-model="interfaceData.show_bid_increments"
        :label="trans('live.tabs.settings.interface_tab.labels.show_bid_increments')" />
    </div>
    <div class="action-block">
      <button class="action btn btn-blue" @click="save">
        {{ trans("live.tabs.settings.labels_tab.actions.save") }}
      </button>
    </div>
  </div>
</template>

<script setup lang="ts">
  import { trans } from "@/utils/trans";
  import { computed, ref, watch } from "vue";
  import { useAuctionStore } from "@/stores/AuctionStore";
  import SettingThirdButton from "../../../../../enum/SettingThirdButton";
  import apiClient from "@/services/api";
  import CustomCheckbox from "@/components/_partials/widget/CustomCheckbox.vue";
  import { useToast } from "primevue/usetoast";
  const toast = useToast();
  const auctionStore = useAuctionStore();

  const options = computed<{ value: number; label: string }[]>(() => {
    const result = [] as { value: number; label: string }[];
    for (let i = 1; i <= 300; i++) {
      result.push({
        value: i,
        label: `${i} sec`
      });
    }

    return result;
  });

  const interfaceData = ref({
    bidding_duration: auctionStore.liveSettings?.bidding_duration,
    warning_flashing_duration: auctionStore.liveSettings?.warning_flashing_duration,
    third_button: auctionStore.liveSettings?.third_button,
    show_bid_increments: auctionStore.liveSettings?.show_bid_increments
  });

  watch(
    () => auctionStore.liveSettings,
    (nv) => {
      interfaceData.value.bidding_duration = nv?.bidding_duration;
      interfaceData.value.warning_flashing_duration = nv?.warning_flashing_duration;
      interfaceData.value.third_button = nv?.third_button;
      interfaceData.value.show_bid_increments = nv?.show_bid_increments;
    },
    { deep: true }
  );

  const save = () => {
    apiClient.put(auctionStore.routes["auctions.update_live_settings"], interfaceData.value).then((response) => {
      if (response.data.status && response.data.settings) {
        auctionStore.$patch(response.data.settings);
      } else {
        console.log(response, response.data?.message);
      }
      toast.add({
        severity: response.data.status ? "success" : "error",
        summary: trans("live.toast." + (response.data.status ? "success" : "error")),
        detail: response.data.message || trans("live.toast.unknown_error"),
        life: 6000
      });
    });
  };
</script>
